module.exports = __webpack_public_path__ + "img/banner1.16b03e8f.png";